import { useInspection } from "../hooks/useInspection";

export default function Activity() {
  const inspection = useInspection();
  return <div>Activity {JSON.stringify(inspection)}</div>;
}
